// splineUtils.js — Shared Catmull-Rom spline utilities for path/lane editing.

/** Samples per segment used for edit-mode hit detection and rendering. */
export const SPLINE_SAMPLES_EDIT = 12;

/**
 * Catmull-Rom spline through points; returns interpolated path (lat/lng).
 * @param points - Array of { lat, lng }
 * @param numSamplesPerSegment - samples between each pair of points (default 16)
 * @returns Array of { lat, lng } along the curve
 */
export function catmullRomSpline(points, numSamplesPerSegment = 16) {
  if (!points?.length) return [];
  if (points.length === 1) return [points[0]];
  const out = [];
  const n = points.length;
  for (let i = 0; i < n - 1; i++) {
    const p0 = points[Math.max(0, i - 1)];
    const p1 = points[i];
    const p2 = points[i + 1];
    const p3 = points[Math.min(n - 1, i + 2)];
    for (let j = 0; j < numSamplesPerSegment; j++) {
      const t = j / numSamplesPerSegment;
      const t2 = t * t;
      const t3 = t2 * t;
      const lat = 0.5 * ((2 * p1.lat) + (-p0.lat + p2.lat) * t + (2 * p0.lat - 5 * p1.lat + 4 * p2.lat - p3.lat) * t2 + (-p0.lat + 3 * p1.lat - 3 * p2.lat + p3.lat) * t3);
      const lng = 0.5 * ((2 * p1.lng) + (-p0.lng + p2.lng) * t + (2 * p0.lng - 5 * p1.lng + 4 * p2.lng - p3.lng) * t2 + (-p0.lng + 3 * p1.lng - 3 * p2.lng + p3.lng) * t3);
      out.push({ lat, lng });
    }
  }
  out.push(points[n - 1]);
  return out;
}
